export type NotifyStandardExportProgressData = [
  notificationID: string,
  downloadID: string,
  percentage: number,
  status: string,
  stepDescription: string
]

const EXPORT_HUB = {
  // Plan Export
  NOTIFY_EXPORT_PROGRESS: 'NotifyExportProgress',
  NOTIFY_EXPORT_FAILED: 'NotifyExportFailed',

  // Plan Preview
  NOTIFY_PREVIEW_COMPLETED: 'NotifyPreviewCompleted',
  NOTIFY_PREVIEW_FAILED: 'NotifyPreviewFailed',

  // Plan Summaries
  NOTIFY_OVERVIEW_SUMMARY_EXPORT_COMPLETED:
    'NotifyOverviewSummaryExportCompleted',
  NOTIFY_OVERVIEW_SUMMARY_EXPORT_FAILED: 'NotifyOverviewSummaryExportFailed',
  NOTIFY_PLAN_SUMMARY_EXPORT_COMPLETED: 'NotifyPlanSummaryExportCompleted',
  NOTIFY_PLAN_SUMMARY_EXPORT_FAILED: 'NotifyPlanSummaryExportFailed',

  // Plan Data Export
  NOTIFY_DATA_EXPORT_COMPLETED: 'NotifyDataExportCompleted',

  // Plan GFE Export
  NOTIFY_GFE_EXPORT_COMPLETED: 'NotifyGFEExportCompleted',

  // Project Export
  NOTIFY_STANDARD_EXPORT_PROGRESS: 'NotifyStandardExportProgress',
  NOTIFY_STANDARD_EXPORT_FAILED: 'NotifyStandardExportFailed',
  NOTIFY_STANDARD_EXPORT_COMPLETED: 'NotifyStandardExportCompleted',
}

const EXPORT_HUB_EVENT_NAMES = Object.values(EXPORT_HUB)

const NOTIFICATION_HUB = {
  NOTIFY_PLAN_UNPUBLISHED: 'NotifyPlanUnpublished',
  NEW_NOTIFICATION_RECEIVED: 'NewNotificationReceived',
}

const NOTIFICATION_HUB_EVENT_NAMES = Object.values(NOTIFICATION_HUB)

export const SIGNALR_EVENTS = {
  EXPORT_HUB,
  EXPORT_HUB_EVENT_NAMES,

  NOTIFICATION_HUB,
  NOTIFICATION_HUB_EVENT_NAMES,
}
